import { render, staticRenderFns } from "./BFlowTaskProps.vue?vue&type=template&id=13967036"
import script from "./BFlowTaskProps.vue?vue&type=script&lang=js"
export * from "./BFlowTaskProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports